<div class="dialog-box">
    <div class="icon">
      <img src="./assets/img/Imagem arquivo errado.png" alt="Ícone de Erro">
    </div>
    <h2>Sinto muito, o formato do arquivo não permite vizualização <br> Clique no botão download para baixar</h2>
  </div>
  